import { Row, Col } from "react-bootstrap";
import "./CVimage.css";
import { images } from "../../../../../constants/index";
import ProfileInformationCV from "../profileInformation";
import CVProfileBio from "../CVProfileBio";
import { getAsset } from "../../../../../helpers/helper";
import dummyezi from "../../../../../assets/images/dummy/dummyezi.png";

const CVImage = ({ cvdata }) => {
  return (

    <Row>
      <Col md={4} lg={4} xl={4} >
        <div className="leftsideback d-flex flex-column align-items-center">
          <div className="pt-2 p-3">
            <div className="img-Background ">
              <img
                src={getAsset(cvdata?.profileInformation?.photo || cvdata?.user?.imageUrl)}
                onError={(e) => { e.target.onerror = null; e.target.src = dummyezi; }}
                crossOrigin="anonymous"
                alt=""
                className="img-Background"
              />
            </div>
            <div className="profile-1-scroll noscroll ps-md-2 ps-lg-2 ps-xl-0">
              <ProfileInformationCV cvdata={cvdata} />
            </div>
          </div>
        </div>
      </Col>
      <Col md={8} lg={8} xl={8} className="pe-0">
        <CVProfileBio cvdata={cvdata} />
      </Col>
    </Row>

  );
};
export default CVImage;
